/**
 * Meal Plan Builder JavaScript - UPDATED
 * Handles multi-step form, meal selection, filtering, and cart integration
 */

(function($) {
  'use strict';

  // If the script ends up on the page twice, only the first copy runs. A second copy
  // would bind every handler again and keep its own state, which the datepicker
  // (bound to the field only once) would never fill in.
  if (window.MealPlanBuilderLoaded) return;
  window.MealPlanBuilderLoaded = true;

  const MealPlanBuilder = {
    // Configuration
    config: {
      section: null,
      collections: {
        'type-one': '',
        'type-two': '',
        'pre-diabetes': ''
      },
      pricePerMeal: 10,
      currentStep: 1,
      totalSteps: 3
    },

    // State management
    state: {
      dietaryType: null,
      mealsCount: 10,
      deliveryDate: null,
      selectedMeals: [],
      allMeals: [],
      filteredMeals: [],
      activeFilters: []
    },

    // Collection filters (not persisted)
    filters: {
      collection: null,
      params: '',
      request: 0,
      timer: null
    },

    /**
     * Initialize the meal plan builder
     */
    init: function(sectionId) {
      this.config.section = $('[data-section-id="' + sectionId + '"]');
      if (!this.config.section.length) return;

      // Get collections from section settings
      this.getCollectionSettings();

      // Initialize multi-step form
      this.initMultiStepForm();

      // Bind event listeners
      this.bindEvents();

      // Load initial state from localStorage if exists
      this.loadSavedState();
    },

    /**
     * Get collection handles from section settings
     */
    getCollectionSettings: function () {
      const section = this.config.section;

      this.config.collections['type-one'] = section.attr('data-type-one-collection') || '';
      this.config.collections['type-two'] = section.attr('data-type-two-collection') || '';
      this.config.collections['pre-diabetes'] = section.attr('data-pre-diabetes-collection') || '';
      this.config.pricePerMeal = parseFloat(section.attr('data-price-per-meal')) || 10;
      
      console.log('Collection settings loaded:', this.config.collections);
    },

    /**
     * Initialize multi-step form
     */
    initMultiStepForm: function() {
      const self = this;
      const form = $('#mrk-meal-plan-form');

      this.navigateTo = function(index) {
        const tabs = form.find('.mrk-tab');
        const steps = $('.mrk-step');

        self.config.currentStep = index + 1;

        tabs.removeClass('current').eq(index).addClass('current');

        steps.each(function(i) {
          const step = $(this);
          if (i < index) {
            step.addClass('completed').removeClass('active');
          } else if (i === index) {
            step.addClass('active').removeClass('completed');
          } else {
            step.removeClass('active completed');
          }
        });

        const progressPercent = (index / (self.config.totalSteps - 1)) * 100;
        $('.mrk-step-progress').css('width', progressPercent + '%');

        form.find('.mrk-btn-previous').toggle(index > 0);
        form.find('.mrk-btn-next').toggle(index < self.config.totalSteps - 1);
        form.find('.mrk-btn-checkout').toggle(index === self.config.totalSteps - 1);

        $('html, body').animate({ scrollTop: self.config.section.offset().top - 100 }, 300);

        if (index === 1) {
          self.loadMeals();
        } else if (index === 2) {
          self.updateCheckoutSummary();
        }

        self.saveState();
      };

      this.navigateTo(0);
    },

    /**
     * Bind all event listeners
     */
    bindEvents: function() {
      const self = this;

      // Initialize datepicker
      $('#mrk-delivery-date').datepicker({
        minDate: 0,
        maxDate: '+2M',
        dateFormat: 'DD, d MM yy',
        beforeShowDay: function (date) {
          const day = date.getDay();
          return [(day === 0), ''];
        },
        onSelect: function (dateText) { 
          self.state.deliveryDate = dateText;
          self.saveState();
        }
      });

      // Step 1: Plan selections
      $('input[name="dietary_type"]').on('change', function() {
        self.state.dietaryType = $(this).val();
        self.saveState();
      });

      $('input[name="meals_count"]').on('change', function() {
        self.state.mealsCount = parseInt($(this).val());
        self.updateMealCounter();
        self.saveState();
      });

      // Filters drawer (mobile / tablet)
      $('.mrk-filters-btn').on('click', function() {
        $('.mrk-filters-wrapper, .mrk-filters-overlay').addClass('active');
      });

      $('[data-filters-close], .mrk-filters-overlay').on('click', function() {
        $('.mrk-filters-wrapper, .mrk-filters-overlay').removeClass('active');
      });

      // Navigation buttons
      $('.mrk-btn-previous').on('click', function() {
        self.navigateTo(self.config.currentStep - 2);
      });

      $('.mrk-btn-next').on('click', function() {
        if (self.validateCurrentStep()) {
          self.navigateTo(self.config.currentStep);
        }
      });

      $('.mrk-btn-checkout').on('click', function() {
        if ($(this).prop('disabled')) return;
        self.proceedToCheckout();
      });

      // Step indicators click
      $('.mrk-step').on('click', function() {
        const stepIndex = parseInt($(this).data('step')) - 1;
        if (stepIndex < self.config.currentStep - 1) {
          self.navigateTo(stepIndex);
        }
      });

      // Carb filters
      $('input[name="carb_filter"]').on('change', function() {
        self.updateFilters();
      });

      // Collection filters (loaded with the meals)
      const filtersWrapper = $('.mrk-filters-wrapper');

      filtersWrapper.on('click', '.mrk-filter-group-title', function() {
        const group = $(this).closest('.mrk-filter-group');
        group.toggleClass('open');
        $(this).attr('aria-expanded', group.hasClass('open'));
      });

      filtersWrapper.on('change', '[data-mrk-filters-form] input[type="checkbox"]', function() {
        self.applyCollectionFilters();
      });

      // Price range: keep sliders and inputs in sync
      filtersWrapper.on('input', '[data-price-slider]', function() {
        self.syncPriceRange($(this).closest('[data-mrk-price-range]'), $(this).data('price-slider'), 'slider');
      });

      filtersWrapper.on('change', '[data-price-slider]', function() {
        self.applyCollectionFilters();
      });

      filtersWrapper.on('change', '[data-price-input]', function() {
        self.syncPriceRange($(this).closest('[data-mrk-price-range]'), $(this).data('price-input'), 'input');
        self.applyCollectionFilters();
      });

      filtersWrapper.on('keydown', '[data-price-input]', function(e) {
        if (e.key === 'Enter') {
          e.preventDefault();
          $(this).trigger('change');
        }
      });

      $('[data-filters-clear]').on('click', function() {
        $('input[name="carb_filter"]').prop('checked', false);
        self.filters.params = '';
        self.loadMeals();
      });

      // Meal card actions
      $(document).on('click', '.mrk-btn-add', function(e) {
        e.stopPropagation();
        const card = $(this).closest('.mrk-meal-card');
        const productId = card.data('product-id');
        self.addMeal(productId);
      });

      $(document).on('click', '.mrk-btn-remove', function(e) {
        e.stopPropagation();
        const card = $(this).closest('.mrk-meal-card');
        const productId = card.data('product-id');
        self.removeMeal(productId);
      });

      // View meal details (closing, tabs and escape key are handled in meal-detail-modal.js)
      $(document).on('click', '.mrk-view-details, .mrk-meal-image-wrapper, .mrk-meal-title', function () {
        const handle = $(this).closest('[data-product-handle]').data('product-handle');
        self.openMealModal(handle);
      });

      // Modal actions
      $(document).on('click', '.mrk-btn-modal-add', function() {
        self.addMeal(window.MrkMealModal.currentProductId);
      });

      $(document).on('click', '.mrk-btn-modal-remove', function() {
        self.removeMeal(window.MrkMealModal.currentProductId);
      });

      // Edit order button
      $('.mrk-edit-order').on('click', function() {
        self.navigateTo(1);
      });
    },

    /**
     * The chosen delivery date
     *
     * The date field is the source of truth: the datepicker only fills in the state
     * when its own onSelect runs, so read the field and keep the state in step with it.
     */
    getDeliveryDate: function() {
      const fieldValue = $('#mrk-delivery-date').val();
      if (fieldValue) this.state.deliveryDate = fieldValue;

      return this.state.deliveryDate || '';
    },

    /**
     * Validate current step before proceeding
     */
    validateCurrentStep: function() {
      const step = this.config.currentStep;

      if (step === 1) {
        if (!this.state.dietaryType) {
          alert('Please select a dietary type');
          return false;
        }
        if (!this.state.mealsCount) {
          alert('Please select meals per week');
          return false;
        }
        if (!this.getDeliveryDate()) {
          alert('Please select a delivery date');
          return false;
        }
        this.saveState();
        return true;
      }

      if (step === 2) {
        const selectedCount = this.state.selectedMeals.reduce((sum, meal) => sum + meal.quantity, 0);
        if (selectedCount < this.state.mealsCount) {
          alert('Please select ' + this.state.mealsCount + ' meals to continue');
          return false;
        }
        return true;
      }

      return true;
    },

    /**
     * Load meals based on dietary type (and the active collection filters)
     */
    loadMeals: function() {
      const self = this;
      const collectionHandle = this.config.collections[this.state.dietaryType];
      const grid = $('.mrk-meals-grid');

      if (!collectionHandle) {
        console.error('Collection not found for dietary type:', this.state.dietaryType);
        grid.html('<div class="mrk-meals-loading"><p>Collection not configured. Please set up collections in section settings.</p></div>');
        return;
      }

      // Filters belong to a collection - reset them when the dietary type changes
      if (this.filters.collection !== collectionHandle) {
        this.filters.collection = collectionHandle;
        this.filters.params = '';
        $('input[name="carb_filter"]').prop('checked', false);
        $('[data-filters-container]').empty();
        grid.empty();
      }

      // Keep the current meals visible while filtering
      if (grid.find('.mrk-meal-card').length) {
        grid.addClass('mrk-loading');
      } else {
        grid.html('<div class="mrk-meals-loading"><p>Loading meals...</p></div>');
      }

      // Carb level filter is for Type Two only
      $('.mrk-filter-group-carb').toggle(this.state.dietaryType === 'type-two');

      let url = '/collections/' + collectionHandle + '?view=products-ajax';
      if (this.filters.params) {
        url += '&' + this.filters.params;
      }

      // Ignore responses of outdated requests
      const requestId = ++this.filters.request;

      $.ajax({
        url: url,
        method: 'GET',
        dataType: 'html',
        success: function(html) {
          if (requestId !== self.filters.request) return;

          const response = $('<div>').html(html || '');
          const products = response.find('[data-mrk-ajax-products]');
          const filters = response.find('[data-mrk-ajax-filters]');

          if (!filters.length) {
            console.warn(
              'Meal plan builder: no filters in the response. Check that templates/collection.products-ajax.liquid ' +
                'and snippets/mrk-builder-filters.liquid are on the theme, and that filters are set up in Search & Discovery.'
            );
          }

          grid.removeClass('mrk-loading').html(products.length ? products.html() : html);
          self.renderCollectionFilters(filters.length ? filters.html() : '');

          // Keep meals from earlier loads, so selected meals are not lost when they are filtered out
          self.state.filteredMeals = [];
          grid.find('.mrk-meal-card').each(function() {
            const card = $(this);
            let productData = JSON.parse(card.find('[data-product-json]').html());
            self.state.filteredMeals.push(productData);

            const index = self.state.allMeals.findIndex(p => p.id === productData.id);
            if (index > -1) {
              self.state.allMeals[index] = productData;
            } else {
              self.state.allMeals.push(productData);
            }
          });

          self.updateFilters();
          self.updateMealCardStates();
          self.updateMealCounter();
        },
        error: function(xhr, status, error) {
          if (requestId !== self.filters.request) return;
          console.error('Error loading meals:', error);

          let errorMsg = 'Error loading meals. ';
          if (xhr.status === 404) {
            errorMsg += 'Collection "' + collectionHandle + '" not found. Please check collection handle in section settings.';
          } else {
            errorMsg += 'Please try again or contact support.';
          }

          grid.removeClass('mrk-loading').html('<div class="mrk-meals-loading"><p>' + errorMsg + '</p></div>');
        }
      });
    },

    /**
     * Render the collection filters returned with the meals
     */
    renderCollectionFilters: function(html) {
      const container = $('[data-filters-container]');

      // Remember collapsed groups and the focused input
      const collapsed = container.find('.mrk-filter-group:not(.open)').map(function() {
        return $(this).attr('data-filter-group');
      }).get();
      const focused = container.find('input:focus');
      const focusedName = focused.attr('name');
      const focusedValue = focused.is(':checkbox') ? focused.val() : null;

      container.html(html);

      container.find('.mrk-filter-group').each(function() {
        if (collapsed.indexOf($(this).attr('data-filter-group')) > -1) {
          $(this).removeClass('open').find('.mrk-filter-group-title').attr('aria-expanded', 'false');
        }
      });

      if (focusedName) {
        container.find('input').filter(function() {
          return $(this).attr('name') === focusedName && (focusedValue === null || $(this).val() === focusedValue);
        }).first().trigger('focus');
      }
    },

    /**
     * Reload meals with the selected collection filters
     */
    applyCollectionFilters: function() {
      const self = this;

      clearTimeout(this.filters.timer);
      this.filters.timer = setTimeout(function() {
        const params = new URLSearchParams();

        $('[data-mrk-filters-form] input[name]').each(function() {
          const input = $(this);
          if (input.is(':checkbox')) {
            if (input.prop('checked')) params.append(input.attr('name'), input.val());
          } else if (input.val() !== '') {
            params.append(input.attr('name'), input.val());
          }
        });

        self.filters.params = params.toString();
        self.loadMeals();
      }, 400);
    },

    /**
     * Keep price range sliders, inputs and track in sync
     */
    syncPriceRange: function(range, changed, source) {
      const rangeMax = parseInt(range.attr('data-range-max')) || 0;
      const minSlider = range.find('[data-price-slider="min"]');
      const maxSlider = range.find('[data-price-slider="max"]');
      const minInput = range.find('[data-price-input="min"]');
      const maxInput = range.find('[data-price-input="max"]');

      let min = parseInt(source === 'slider' ? minSlider.val() : minInput.val());
      let max = parseInt(source === 'slider' ? maxSlider.val() : maxInput.val());
      if (isNaN(min)) min = 0;
      if (isNaN(max)) max = rangeMax;

      min = Math.max(0, Math.min(min, rangeMax));
      max = Math.max(0, Math.min(max, rangeMax));
      if (min > max) {
        if (changed === 'min') {
          min = max;
        } else {
          max = min;
        }
      }

      minSlider.val(min);
      maxSlider.val(max);
      // Leave the inputs empty at the ends of the range, so no price filter is applied
      minInput.val(min > 0 ? min : '');
      maxInput.val(max < rangeMax ? max : '');

      if (rangeMax > 0) {
        range.css('--from', (min / rangeMax) * 100 + '%');
        range.css('--to', (max / rangeMax) * 100 + '%');
      }
    },

    /**
     * Update carb level filters (applied on top of the collection filters)
     */
    updateFilters: function() {
      const self = this;
      this.state.activeFilters = [];

      $('input[name="carb_filter"]:checked').each(function() {
        self.state.activeFilters.push($(this).val());
      });

      let visibleCount = 0;

      $('.mrk-meal-card').each(function() {
        const card = $(this);
        const carbLevel = String(card.data('carb-level') || '');

        const matches = self.state.activeFilters.length === 0 || self.state.activeFilters.some(function(filter) {
          return carbLevel.toLowerCase().includes(filter.toLowerCase());
        });

        card.toggle(matches);
        if (matches) visibleCount++;
      });

      const hasActiveFilters = this.state.activeFilters.length > 0 || this.filters.params !== '';

      $('.mrk-meals-grid .mrk-meals-loading').remove();
      if (visibleCount === 0) {
        const message = hasActiveFilters ? 'No meals match your filters.' : 'No meals found in this collection.';
        $('.mrk-meals-grid').append('<div class="mrk-meals-loading mrk-no-meal"><p>' + message + '</p></div>');
      }

      $('[data-filters-clear]').toggle(hasActiveFilters);
    },

    /**
     * Add meal to selection
     */
    addMeal: function(productId) {
      const currentTotal = this.state.selectedMeals.reduce((sum, meal) => sum + meal.quantity, 0);
      
      if (currentTotal >= this.state.mealsCount) {
        alert('You have already selected ' + this.state.mealsCount + ' meals');
        return;
      }
      
      const existingMeal = this.state.selectedMeals.find(m => m.id === productId);
      const product = this.state.allMeals.find(p => p.id === productId);
      
      if (!product) return;
      
      if (existingMeal) {
        existingMeal.quantity++;
      } else {
        this.state.selectedMeals.push({
          id: productId,
          title: product.title,
          handle: product.handle,
          image: product.image ? product.image : null,
          price: product.variants[0].price,
          quantity: 1
        });
      }
      
      this.updateMealCardStates();
      this.updateMealCounter();
      this.saveState();
    },

    /**
     * Remove meal from selection
     */
    removeMeal: function(productId) {
      const existingMeal = this.state.selectedMeals.find(m => m.id === productId);
      
      if (!existingMeal) return;
      
      if (existingMeal.quantity > 1) {
        existingMeal.quantity--;
      } else {
        this.state.selectedMeals = this.state.selectedMeals.filter(m => m.id !== productId);
      }
      
      this.updateMealCardStates();
      this.updateMealCounter();
      this.saveState();
    },

    /**
     * Update meal card visual states
     */
    updateMealCardStates: function() {
      const self = this;
      
      $('.mrk-meal-card').each(function() {
        const card = $(this);
        const productId = card.data('product-id');
        const selectedMeal = self.state.selectedMeals.find(m => m.id === productId);
        const quantity = selectedMeal ? selectedMeal.quantity : 0;
        
        if (quantity > 0) {
          card.addClass('selected');
        } else {
          card.removeClass('selected');
        }
        $(card).find('.mrk-current-selected-count').text(quantity);
      });
    },

    /**
     * Update meal counter display
     */
    updateMealCounter: function() {
      const selectedCount = this.state.selectedMeals.reduce((sum, meal) => sum + meal.quantity, 0);
      const remaining = this.state.mealsCount - selectedCount;
      const progress = (selectedCount / this.state.mealsCount) * 100;
      
      $('.mrk-selected-count').text(selectedCount);
      $('.mrk-total-count').text(this.state.mealsCount);
      $('.mrk-remaining-count').text(remaining);
      $('.mrk-progress-fill').css('width', progress + '%');

      if (selectedCount === this.state.mealsCount) {
        $('.mrk-counter-message').html('<strong style="color: rgb(var(--color-success));">Ready to proceed!</strong>');
        $('html, body').animate({
            scrollTop: $('.mrk-meal-counter-sticky').offset().top - 100
        }, 800);
      } else if (remaining > 0) {
        $('.mrk-counter-message').html('Select <strong class="mrk-remaining-count">' + remaining + '</strong> more meal' + (remaining > 1 ? 's' : '') + ' to continue.');
      }

      if (this.config.currentStep === 2) {
        $('.mrk-btn-checkout').prop('disabled', selectedCount < this.state.mealsCount);
      }
    },

    /**
     * Open meal detail modal (see meal-detail-modal.js)
     */
    openMealModal: function(handle) {
      const product = this.state.allMeals.find(p => p.handle === handle);

      if (product && window.MrkMealModal) {
        window.MrkMealModal.open(product);
      }
    },

    /**
     * Update checkout summary
     */
    updateCheckoutSummary: function () {
      const dietaryTypeMap = {
        'type-one': 'Type One Diabetes',
        'type-two': 'Type Two Diabetes',
        'pre-diabetes': 'Pre Diabetes'
      };
      
      $('[data-summary="dietary-type"]').text(dietaryTypeMap[this.state.dietaryType] || '-');
      $('[data-summary="meals-count"]').text(this.state.mealsCount + ' meals');
      $('[data-summary="delivery-date"]').text(this.getDeliveryDate() || '-');

      const mealsList = $('[data-summary-meals]');
      mealsList.empty();
      
      this.state.selectedMeals.forEach(function(meal) {
        const item = $('<div class="mrk-summary-meal-item">');
        item.append('<span class="mrk-summary-meal-qty">' + meal.quantity + 'x</span>');
        item.append('<span class="mrk-summary-meal-name">' + meal.title + '</span>');
        mealsList.append(item);
      });
      const sum = 0;
      console.log(this.state.selectedMeals);
      const subtotal = this.state.selectedMeals.reduce((sum, meal) => sum + (Number(meal.price) * Number(meal.quantity)), 0);
      const total = subtotal;
      
      $('[data-summary="subtotal"]').text(formatMoney(subtotal));
      $('[data-summary="total"]').text(formatMoney(total));
    },

    /**
     * Proceed to Shopify checkout
     */
    proceedToCheckout: function() {
      const self = this;

      const email = $('#customer-email').val();
      if (!email) {
        alert('Please enter your email address');
        return;
      }
      
      const cartNote = $('#cart-note').val();
      const deliveryDate = this.getDeliveryDate();

      const items = [];
      this.state.selectedMeals.forEach(function(meal) {
        const product = self.state.allMeals.find(p => p.id === meal.id);
        if (product && product.variants && product.variants.length > 0) {
          items.push({
            id: product.variants[0].id,
            quantity: meal.quantity,
            properties: {
              'Dietary Type': self.state.dietaryType,
              'Delivery Date': deliveryDate
            }
          });
        }
      });

      $.ajax({
        url: '/cart/add.js',
        method: 'POST',
        dataType: 'json',
        contentType: 'application/json',
        data: JSON.stringify({ items: items }),
        success: function () {
          $.ajax({
            url: '/cart/update.js',
            method: 'POST',
            dataType: 'json',
            contentType: 'application/json',
            data: JSON.stringify({
              note: cartNote,
              attributes: {
                'Customer Email': email,
                'Dietary Type': self.state.dietaryType,
                'Delivery Date': deliveryDate,
                'Meal Plan Size': self.state.mealsCount
              }
            }),
            success: function () {
              self.clearState();
              window.location.href = '/checkout';
            },
            error: function(xhr, status, error) {
              console.error('Error updating cart:', error);
              alert('Unable to update cart. Please try again.');
            }
          });
        },
        error: function(xhr, status, error) {
          console.error('Error adding to cart:', error);
          alert('Unable to add meals to cart. Please try again.');
        }
      });
    },

    /**
     * Save state to localStorage
     */
    saveState: function() {
      try {
        localStorage.setItem('mealPlanState', JSON.stringify(this.state));
      } catch(e) {
        console.error('Error saving state:', e);
      }
    },

    /**
     * Load saved state from localStorage
     */
    loadSavedState: function() {
      try {
        const saved = localStorage.getItem('mealPlanState');
        if (saved) {
          const state = JSON.parse(saved);

          if (state.dietaryType) {
            this.state.dietaryType = state.dietaryType;
            $('input[name="dietary_type"][value="' + state.dietaryType + '"]').prop('checked', true);
          }
          
          if (state.mealsCount) {
            this.state.mealsCount = state.mealsCount;
            $('input[name="meals_count"][value="' + state.mealsCount + '"]').prop('checked', true);
          }
          
          if (state.deliveryDate) {
            this.state.deliveryDate = state.deliveryDate;
            // The field is an input, so put the saved date back into it
            $('#mrk-delivery-date').val(state.deliveryDate);
          }
          
          if (state.selectedMeals) {
            this.state.selectedMeals = state.selectedMeals;
          }
        }
      } catch(e) {
        console.error('Error loading state:', e);
      }
    },

    /**
     * Clear saved state
     */
    clearState: function() {
      try {
        localStorage.removeItem('mealPlanState');
      } catch(e) {
        console.error('Error clearing state:', e);
      }
    }
  };

  // Initialize when document is ready
  $(document).ready(function () {
    const sectionId = $('.mrk-meal-plan-builder').data('section-id');
    if (sectionId) {
      MealPlanBuilder.init(sectionId);
    }
  });

})(jQuery);